export const queryKeyUseInsightsPerDateQuery = 'queryKeyUseInsightsPerDateQuery';
export const queryKeyUseInsightsPerDateQueryMinimal = 'queryKeyUseInsightsPerDateQueryMinimal';
